module.exports = __webpack_public_path__ + "static/img/img_chrome.04a657e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/img_chrome.png
// module id = Vgax
// module chunks = 25